
import IDynamicFormRow from '../../yoello-lib/modules/dynamicForms/interfaces/IDynamicFormRow';
export type TabContainer = { key: string, title?: string, items?: Tab[] }
export interface ITabs {
  direction: string;
  tabs: TabContainer[]
}

export interface IProfileForms {
  transformFunction?: (data: any) => any;
  title: string;
  formKey: string;
  formButtonText?: string;
  subTitle?: string;
  formRows: IDynamicFormRow[];
  disable?:boolean
}
export interface ActiveTab {
  key: string;
}


export enum CollectionTabs {
  COLLECTION = 'Collection',
  PICKUP = 'Pickup'
}